import { render, staticRenderFns } from "./merchantUpdate.vue?vue&type=template&id=c3150112&scoped=true&"
import script from "./merchantUpdate.vue?vue&type=script&lang=js&"
export * from "./merchantUpdate.vue?vue&type=script&lang=js&"
import style0 from "./merchantUpdate.vue?vue&type=style&index=0&id=c3150112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3150112",
  null
  
)

component.options.__file = "merchantUpdate.vue"
export default component.exports